import WarningAmberIcon from '@mui/icons-material/WarningAmber';
import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogProps,
  DialogTitle,
  Typography,
  useMediaQuery,
  useTheme,
} from '@mui/material';
import { styled } from '@mui/styles';
import { memo } from 'react';
import { PmiButton } from 'shell/components/shared/button';
export const PmiDialog = styled((props: DialogProps) => <Dialog {...props} />)((props) => ({
  '& .MuiDialog-paper': props.fullScreen
    ? {
        minWidth: 'unset',
        maxWidth: '100%',
      }
    : {
        minWidth: '25rem',
        maxWidth: '30rem',
      },
}));

interface ModalAlreadyInCohabitationProps {
  open: boolean;
  onClose: (open: boolean) => void;
  onConfirm: () => void;
}

const ModalAlreadyInCohabitationComponent = ({
  open,
  onClose,
  onConfirm,
}: ModalAlreadyInCohabitationProps): React.ReactElement => {
  const theme = useTheme();
  const fullScreen = useMediaQuery(theme.breakpoints.down(theme.breakpoints.values.md));

  return (
    <PmiDialog
      open={open}
      onClose={() => onClose(false)}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
      fullScreen={fullScreen}
    >
      <DialogTitle
        sx={{
          textAlign: 'center',
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
        }}
      >
        <WarningAmberIcon color="error" sx={{ fontSize: 28 }} />
        <Typography variant="h5" component="span" sx={{ ml: 0.5 }}>
          Attenzione
        </Typography>
      </DialogTitle>
      <DialogContent style={{ padding: '30px 24px' }}>
        <Typography variant="body1" align="center" component="p">
          La persona selezionata si trova in una convivenza di fatto.
        </Typography>
      </DialogContent>
      <DialogActions sx={{ justifyContent: 'center', pb: 3 }}>
        <PmiButton
          variant="contained"
          color="primary"
          size="large"
          fullWidth={fullScreen}
          autoFocus
          onClick={onConfirm}
        >
          Ho capito
        </PmiButton>
      </DialogActions>
    </PmiDialog>
  );
};

ModalAlreadyInCohabitationComponent.displayName = 'Modal Already In Cohabitation';

const ModalAlreadyInCohabitation = memo(ModalAlreadyInCohabitationComponent);

export default ModalAlreadyInCohabitation;
